import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import NavigationMenu from "./components/navigation-menu";
import Toolbar from "./components/toolbar";

const HeaderRoot = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1100;
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-border-subtle);
`;

const Header = ({ routes, headerVisible }) => {
  return (
    <HeaderRoot className="ds-root">
      <Toolbar />
      {headerVisible ? <NavigationMenu allowedRoutes={routes} /> : null}
    </HeaderRoot>
  );
};

const mapStateToProps = (state) => ({
  headerVisible: state.headerVisible,
});

export default connect(mapStateToProps, null)(Header);
